<template>
  <div class="components-wrap" id="components-wrap">
    <div class="video-size-wrap" v-videosize="{ ratio, marginY: 0, marginX: 0 }">
      <component
        v-for="item in compsList"
        :is="`V${item.componentId}`"
        :key="item.id"
        :nodeid="item.id"
        :tplid="item.componentId"
        :isGlobal="item.isGlobal"
        v-bind="propsData[item.id]"
        root="true"
        @interruptdestroy="handleInterrupt(item.id)"
        @requestdestroy="handleRequest(item.id)"
      ></component>
    </div>
  </div>
</template>

<script>
import compsMixin from './mixin/compsMixin';
export default {
  mixins: [compsMixin]
};
</script>

<style>
.components-wrap {
  overflow: hidden;
  height: 100%;
  width: 100%;
}
.video-size-wrap {
  position: absolute;
  margin: auto;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

@keyframes fseqAnimation {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 0 100%;
  }
}

.steps_anim {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 50%;
  left: 50%;
}
</style>
